// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1LdTp","range":"MonthRangeSwitch_range__2_BXl","disabled":"MonthRangeSwitch_disabled__1Xcqp"};